var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"0.083 13.503 1.809 11.777 8.128 18.066 8.128 0.003 10.718 0.003 10.718 18.067 17.037 11.748 18.794 13.505 9.423 22.875"}));
}

Arrow.defaultProps = {"width":"19px","height":"23px","viewBox":"0 0 19 23","fill":"#000000","fillRule":"nonzero"};

module.exports = Arrow;

Arrow.default = Arrow;
